module.exports = "/_next/static/images/Frame@2x-496c272c6bf0aa31b9292ef5e67c36fa.webp";